import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";
import { GroupService } from "../report-services/group.service";
import { GradeLevelService } from "../report-services/grade-level.service";
import { HomeroomService } from "../report-services/homeroom.service";

@Component({
	templateUrl: "./entrytype.component.html",
})
export class EntryTypeComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private gradelevelService: GradeLevelService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		EntryTypeID: 0,
		GradeLevelID: 0,
		GroupID: 0,
		HomeroomID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		NumOfDays: 1,
		ImageLogo: "",
	};

	schoolList: any = [];
	entryList: any = [];
	GradeLevelList: any = [];
	GroupList: any = [];
	HomeroomList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstNumberOfDays = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 12;
	subscription: any;

	ngOnInit() {
		// this.loadSchoolist();
		var i;
		for (i = 1; i < 101; i++) {
			this.lstNumberOfDays.push({
				NumOfDays: i,
			});
		}

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(12);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.report.SchoolID = this.schoolList[0].SchoolID;
					this.EntryType();
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.EntryType();
		this.loadGradeLevelList();
		this.loadHomeroomList();
		this.loadGroupList();
		this.loadLogolist();
	}

	private EntryType() {
		this.report.EntryTypeID = 0;

		var result = this.reportService.EntryTypeGetList();
		result.subscribe(
			(response) => {
				this.entryList = response;

				if (this.entryList.length > 1) {
					this.entryList.unshift({
						EntryTypeID: 0,
						EntryTypeDesc: "All Entry Types",
					});
				} else {
					this.report.EntryTypeID = this.entryList[0].EntryTypeID;
				}
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length > 1) {
					// this.HomeroomList.unshift({
					//     HomeroomId: 0,
					//     HomeRoom: "All Homerooms"
					// })
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				}
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				if (this.GroupList.length > 1) {
					// this.GroupList.unshift({
					//     GroupID: 0,
					//     GroupName: "All Groups"
					// })
					this.report.GroupID = this.GroupList[0].GroupID;
				} else {
					this.report.GroupID = this.GroupList[0].GroupID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.report.SchoolID + "|SchoolID";

		var StartDate = moment(this.report.StartDate).format("MM/DD/YYYY");
		var EndDate = moment(this.report.EndDate).format("MM/DD/YYYY");

		strParam += "," + this.report.EntryTypeID + "|EntryTypeID";

		strParam += "," + StartDate + "|StartDate";
		strParam += "," + EndDate + "|EndDate";
		strParam += "," + this.report.NumOfDays + "|NumOfDays";

		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";
		strParam += "," + this.report.GroupID + "|GroupID";
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		// strParam += "," + vm.searchOptions.sortBy + "|ORDERBY"
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
